import React from 'react';

export const Leaderboard = React.lazy(() => import('./Leaderboard'));
